var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFitpetLogoMonoColor = function SvgFitpetLogoMonoColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 412 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fitpet_logo_mono_color_svg__clip0_13193_30134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.13 0H197.96V98.78H222.26V71.22H229.13C238.574 71.22 247.632 67.4682 254.31 60.7901C260.988 54.1119 264.74 45.0544 264.74 35.61C264.74 26.1657 260.988 17.1081 254.31 10.4299C247.632 3.75176 238.574 0 229.13 0ZM229.19 46.69H222.26V24.3H229.19C230.688 24.2552 232.18 24.5117 233.578 25.0541C234.975 25.5966 236.249 26.414 237.325 27.458C238.401 28.502 239.256 29.7513 239.84 31.1318C240.424 32.5123 240.725 33.9961 240.725 35.495C240.725 36.994 240.424 38.4777 239.84 39.8582C239.256 41.2388 238.401 42.4881 237.325 43.5321C236.249 44.5761 234.975 45.3934 233.578 45.9359C232.18 46.4783 230.688 46.7348 229.19 46.69Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.74 37.24H24.3V24.3H55.78V0H0V98.79H24.3L24.34 61.54H55.78L55.74 37.24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.64 98.79H162.94V24.3H184.85V0H116.73V24.3H138.64V98.79Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.18 98.79H390.48V24.3H412.39V0H344.27V24.3H366.18V98.79Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.01 61.54H331.49V37.24H300.01V24.3H331.49V0H275.71V98.79H331.49V74.49H300.01V61.54Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.89 61.54H95.68L102.58 0H70.99L77.89 61.54Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.89 75.27C84.2476 75.27 81.6646 76.0536 79.4676 77.5216C77.2705 78.9896 75.5582 81.0761 74.547 83.5174C73.5358 85.9586 73.2712 88.6448 73.7867 91.2364C74.3022 93.828 75.5746 96.2085 77.443 98.0769C79.3115 99.9454 81.692 101.218 84.2836 101.733C86.8751 102.249 89.5614 101.984 92.0026 100.973C94.4438 99.9619 96.5304 98.2495 97.9984 96.0525C99.4664 93.8554 100.25 91.2724 100.25 88.63C100.245 85.0884 98.8354 81.6933 96.3311 79.1889C93.8268 76.6846 90.4317 75.2753 86.89 75.27Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fitpet_logo_mono_color_svg__clip0_13193_30134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 102,
    fill: "white"
  })))));
};
export default SvgFitpetLogoMonoColor;